import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { BrokeragePipelinesCalendar } from '../components/BrokeragePipelinesCalendar'
import {
  actionCreators,
  IBrokeragePipelinesCalendarState,
  selectDownloadUrl,
  selectEndTime,
  selectError,
  selectEvents,
  selectIsLoading,
  selectScope,
  selectStartTime,
} from '../modules/brokeragePipelinesCalendar'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IBrokeragePipelinesCalendarState & ICurrentUserState
  >({
    downloadUrl: selectDownloadUrl(),
    endTime: selectEndTime(),
    error: selectError(),
    events: selectEvents(),
    isLoading: selectIsLoading(),
    scope: selectScope(),
    startTime: selectStartTime(),
    user: selectCurrentUser(),
  }),
  actionCreators,
)(BrokeragePipelinesCalendar)
